import { Directive } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
import { CardCVCValidator } from '@sondermind/utilities/tools';

@Directive({
  selector: '[sonderCardCVCValidator]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: CardCVCValidatorDirective, multi: true }
  ]
})
export class CardCVCValidatorDirective implements Validator {
  validate(control: AbstractControl): { [key: string]: any; } | null {
    return CardCVCValidator.format(control);
  }
}
